import { Form } from 'components/organisms';
import { Application } from 'components/templates';
import {
  Account,
  Artist,
  Statement,
  User,
  Watchlist,
  YoutubeOAuth,
} from 'pages/private';
import { Login } from 'pages/public';
import { Navigate, createBrowserRouter } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';

export const routes = createBrowserRouter([
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <Application />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to='/account' />,
      },
      {
        path: 'account',
        children: [
          {
            index: true,
            element: <Account.List />,
          },
          {
            path: ':id',
            element: <Account.Individual />,
            children: Form.Accounts.getRouterTabs(),
          },
          {
            path: 'edit/:id',
            element: <Account.Edit />,
            children: Form.Accounts.getRouterTabs(),
          },
          {
            path: 'create',
            element: <Account.Create />,
            children: Form.Accounts.getRouterTabs(),
          },
        ],
      },
      {
        path: 'artist',
        children: [
          {
            index: true,
            element: <Artist.List />,
          },
          {
            path: ':id',
            element: <Artist.Individual />,
            children: Form.Artist.getRouterTabs(),
          },
          {
            path: 'edit/:id',
            element: <Artist.Edit />,
            children: Form.Artist.getRouterTabs(),
          },
          {
            path: 'create',
            element: <Artist.Create />,
            children: Form.Artist.getRouterTabs(),
          },
        ],
      },
      {
        path: 'statements',
        children: [
          {
            index: true,
            element: <Statement.List />,
          },
          {
            path: ':accountId/:id',
            element: <Statement.Individual />,
            children: [
              { index: true, element: <Navigate to='exchangeRate' replace /> },
              ...(Form.Statements.getRouterTabs?.() ?? []),
            ],
          },
        ],
      },
      {
        path: 'watchlist',
        children: [
          {
            index: true,
            element: <Watchlist.List />,
          },
        ],
      },
      {
        path: 'youtube-oauth',
        children: [
          {
            index: true,
            element: <YoutubeOAuth.List />,
          },
        ],
      },
      {
        path: 'users',
        children: [
          {
            index: true,
            element: <User.List />,
          },
          {
            path: 'create',
            element: <User.Create />,
          },
        ],
      },
    ],
  },
  {
    element: <PublicRoute />,
    children: [
      { path: '*', element: <Navigate to='/login' /> },
      {
        path: 'login',
        element: <Login />,
      },
    ],
  },
]);
